new nc.promokit.Preloader({
    'game': 'lineage2',
    'delay': 600,
    'image': [
        '/promo/lineage2/history/2019/191106_unboxing/img/skill/char-knight.png',
        '/promo/lineage2/history/2019/191106_unboxing/img/skill/char-summonerR.png',
        '/promo/lineage2/history/2019/191106_unboxing/img/skill/char-knight.png',
        '/promo/lineage2/history/2019/191106_unboxing/img/skill/bg-section.jpg',
        '/promo/lineage2/history/2019/191106_unboxing/img/skill/char-wizard.png',
        '/promo/lineage2/history/2019/191106_unboxing/img/skill/char-knight.png',
        '/promo/lineage2/history/2019/191106_unboxing/img/skill/char-knight.png'
    ]
});

$(document).ready(function () {
    $('body').TopBtn();
    $('.toggle-caution').Folding({open: true});

    new nc.promokit.remote({
        element:"#remoteMenu",
        margin:-100,
        top:920,
        fix:287,
        show:true,
        quick:true,
        cspeed:600
    });

    var player_knight = new nc.promokit.Player({
        selector: '#player-knight',
        videoId:'q1tFhG1tXMc',
        mute: true,
        loop: true
    });
    var player_summoner = new nc.promokit.Player({
        selector: '#player-summoner',
        videoId:'1GXjaoFHv-w',
        mute: true,
        loop: true
    });
    var player_wizard = new nc.promokit.Player({
        selector: '#player-wizard',
        videoId:'qCK_A5FOjNs',
        mute: true,
        loop: true
    });
    var player_warrior = new nc.promokit.Player({
        selector: '#player-warrior',
        videoId:'MK4D2aFXEpQ',
        mute: true,
        loop: true
    });

    player_knight.on('canplay',function () {
/*
        player_summoner.on('canplay',function () {
            player_wizard.on('canplay',function () {
                player_warrior.on('canplay',function () {
                    if($('.loader')[0]){
                        console.log('reload');
                        window.location.reload(true);
                    }
                });
            });
        });
*/
        player_knight.play();
        TweenMax.fromTo(".p-slider-list__item-char",1,{x:700,opacity:0},{ease: Power4.easeOut, x:0,opacity:1});
    });

    var slick = $('.slider').slick({
        infinite: true,
        fade : true,
        dots: true,
        arrows: true
    });

    slick.on('beforeChange',function (event, slick, currentSlide, nextSlide) {
        var play_filter = function(slide_num) {
            var player_num;
            switch (slide_num) {
                case 0 :
                    player_num = player_knight;
                    break;
                case 1 :
                    player_num = player_summoner;
                    break;
                case 2 :
                    player_num = player_wizard;
                    break;
                case 3 :
                    player_num = player_warrior;
                    break;
            }
            return player_num;
        };
        play_filter(currentSlide).pause();
        play_filter(nextSlide).seek(1);
        play_filter(nextSlide).play();
        TweenMax.fromTo(".p-slider-list__item-char--summonerL",1,{x:-700,opacity:0},{ease: Power4.easeOut, x:0,opacity:1});
        TweenMax.fromTo(".p-slider-list__item-char",1,{x:700,opacity:0},{ease: Power4.easeOut, x:0,opacity:1});
    })
    setTimeout(function () {
        if($('.loader')[0]){
            console.log('reload');
            window.location.reload(true);
        }
    }, 2000);
});


// WEBPACK FOOTER //
// ./src/js/skill.js